const MobileLanguage = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd" opacity="1">
        <g fill="currentColor" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M10 0C6.741 0 3.849 1.577 2.021 4H2v.027C.75 5.697 0 7.76 0 10c0 5.511 4.489 10 10 10s10-4.489 10-10S15.511 0 10 0zm3 2.584c2.935 1.183 5 4.049 5 7.416 0 2.088-.8 3.978-2.102 5.4-.255-.81-1.003-1.4-1.898-1.4-.552 0-1-.448-1-1v-2c0-.552-.448-1-1-1H8c-.552 0-1-.448-1-1s.448-1 1-1 1-.448 1-1V6c0-.552.448-1 1-1h1c1.105 0 2-.895 2-2v-.416zM2.207 8.207L7 13v1c0 1.105.895 2 2 2v1.932C5.046 17.442 2 14.09 2 10c0-.618.076-1.216.207-1.793z"
                transform="translate(-20 -217) translate(0 99) translate(20 118)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export { MobileLanguage };
